import React from "react";
import "./PaneTopbar.scss";

import { ReactComponent as CloseIcon } from "src/images/cross-alt.svg";
import classNames from "classnames";

interface WithChildren {
  children?: React.ReactNode;
}

interface PaneTopbarColProps extends WithChildren {
  className?: string;
}

interface PaneTopbarToolbarProps extends WithChildren {
  className?: string;
  hidePane?: () => void;
}

function PaneTopbar({ children }: WithChildren) {
  return <div className="pane-top-bar">{children}</div>;
}

function PaneTopbarLeft({ children }: WithChildren) {
  return <div className="pane-top-bar__left">{children}</div>;
}

function PaneTopbarCol({ className, children }: PaneTopbarColProps) {
  return (
    <div className={classNames(["pane-top-bar__col", className])}>
      {children}
    </div>
  );
}

function PaneTopbarToolbar({
  className,
  children,
  hidePane,
}: PaneTopbarToolbarProps) {
  return (
    <div className={classNames(["pane-top-bar__toolbar", className])}>
      {children}
      {hidePane && (
        <CloseIcon className="pane-top-bar__toolbar-icon" onClick={hidePane} />
      )}
    </div>
  );
}

function PaneFooter({ children }: WithChildren) {
  return <div className="pane__footer">{children}</div>;
}

export {
  PaneTopbar,
  PaneTopbarLeft,
  PaneTopbarCol,
  PaneTopbarToolbar,
  PaneFooter,
};
